// 导入样式文件
import './Upload.less';
// 导入React hooks
import { useRef, useState, useCallback, useEffect } from 'react';
// 导入上传工具类
import { VideoProjectUploader } from '@/utils/uppyUpload.js';
// 导入自定义Icon组件
import Icon from '@/components/iconfont/Icon.jsx';

import { captureVideoFrame } from '@/utils/media.js';
import message from '@/utils/message.jsx';
// import { generateProjectName } from '@/utils/recordMedia.js';

// import { useDashboardData } from '@/hooks/DashboardHooks.js';
import { useTranslation } from 'react-i18next';

const videoAccept = {
  accept: '.mp4,.mov',
  text: 'As_CreateProjectRewrite_LocalDes3',
  maxSize: 500 * 1024 * 1024, // 500MB
};

// 上传组件
export default function Upload({ value }) {
  const { accept, text, maxSize } = videoAccept;
  const {
    reset,
    onFileChange,
    onImageBlob,
    onSuccess,
    getTotalMinutes,
    getUploadInstance,
    projectType,
    changePopUpClose,
  } = value;
  const [fileData, setFileData] = useState(null);

  const [uploadFlag, setUploadFlag] = useState(false);
  const [progressNum, setProgressNum] = useState(0);
  // const [uploadInstance, setUploadInstance] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const previousUrl = useRef(null);
  const fileRef = useRef(null);
  const fileUploadStartTime = useRef(0);
  // const { userData } = useDashboardData();
  const { t } = useTranslation();

  useEffect(() => {
    console.log('执行2', reset);
    if (reset) {
      setVideoUrl(null);
      if (previousUrl.current) {
        URL.revokeObjectURL(previousUrl.current);
        previousUrl.current = null;
      }
      setProgressNum(0);
      setFileData(null);
      setUploadFlag(false);
    }
  }, [reset]);

  // useEffect(() => {
  //   if (startUpload) {
  //     handleCreateProject();
  //   }
  // }, [startUpload]);
  // useEffect(() => {
  //   if (startUpload && fileData) {

  //   }
  // }, [startUpload]);

  // 处理弹窗显示和关闭事件的副作用
  // useEffect(() => {
  //   console.log(startUpload, uploadInstance, 'zhixingle');

  //   if (!startUpload) {
  //     if (uploadInstance) {
  //       uploadInstance.stop();
  //     }
  //   }
  // }, [startUpload, uploadInstance]);

  // 上传进度回调
  const handleProgress = (val) => {
    setProgressNum(val);
  };

  // async function checkVideoDuration(file) {
  //   const url = URL.createObjectURL(file);
  //   const limit = userData?.userSubscription?.level > 1 ? 1800 : 600;
  //   let video = document.createElement('video');
  //   video.muted = true;
  //   video.autoplay = true;
  //   await new Promise((resolve) => {
  //     video.addEventListener('canplay', resolve, {
  //       once: true,
  //     });
  //     video.src = url;
  //     video.play();
  //   });
  //   const duration = video.duration;
  //   video.src = '';
  //   video.load();
  //   video = null;
  //   URL.revokeObjectURL(url);
  //   return duration <= limit;
  // }

  // 处理文件选择
  const handleUploadAvatar = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }
    if (fileRef.current) {
      fileRef.current.value = '';
    }
    const allowedExtensions = accept.replace(/\./g, '').split(',');
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      message.warning(t('As_CreateProjectTrans_ErrorUploadFormat'));
      return;
    }
    if (file.size > maxSize) {
      message.warning(t('As_CreateProjectRewrite_ErrorUploadSize'));
      return;
    }
    // const durationChecked = await checkVideoDuration(file);
    // if (!durationChecked) {
    //   message.warning(
    //     t('As_CreateProjectRewrite_ErrorUploadTime', {
    //       time: userData?.userSubscription?.level > 1 ? 30 : 10,
    //     }),
    //   );
    //   return;
    // }
    const url = URL.createObjectURL(file);
    setVideoUrl(url);
    previousUrl.current = url;
    setFileData(file);
    if (onFileChange) {
      onFileChange(file);
    }

    // 获取视频时长 向上取整
    const video = document.createElement('video');
    video.src = url;
    video.onloadedmetadata = () => {
      getTotalMinutes && getTotalMinutes(video.duration);
    };

    window.onClickGATrackEvent('rewrite-file-upload-click');

    setTimeout(() => {
      handleUpload(file);
    }, 10);
  };

  const duration = useRef(0);
  const uploadSnapshot = useCallback(async (file) => {
    const url = URL.createObjectURL(file);
    let video = document.createElement('video');
    video.muted = true;
    video.autoplay = true;
    await new Promise((resolve) => {
      video.addEventListener('canplay', resolve, {
        once: true,
      });
      video.src = url;
      video.play();
    });
    window.onClickGATrackEvent(projectType ? 'addnarration-file-cover' : 'rewrite-file-cover');
    fileUploadStartTime.current = new Date().getTime();
    duration.current = Math.floor(video.duration * 1000);
    await new Promise((resolve) => setTimeout(resolve, 200));
    const imageBlob = await captureVideoFrame(video);
    video.src = '';
    video.load();
    video = null;
    URL.revokeObjectURL(url);
    return imageBlob;
  }, []);

  // 处理文件上传
  const handleUpload = async (file) => {
    setUploadFlag(true);
    handleProgress(0);
    console.log(file, 'filefile');

    const imageBlob = await uploadSnapshot(file);
    if (onImageBlob) {
      const previewUrl = URL.createObjectURL(imageBlob);
      onImageBlob(previewUrl);
    }
    const uploader = new VideoProjectUploader(file, imageBlob);
    // setUploadInstance(uploader);
    getUploadInstance(uploader);
    uploader.on('progress', handleProgress);
    uploader.on('success', ({ stream, thumbnail }) => {
      const time = Math.round((new Date().getTime() - fileUploadStartTime.current) / 1000);
      window.onClickGATrackEvent(
        projectType ? 'addnarration-file-uploaded' : 'rewrite-file-uploaded',
        { upload_duration: time },
      );
      setUploadFlag(false);
      onSuccess && onSuccess(stream, thumbnail, duration);
      // setUploadInstance(null);
      getUploadInstance(null);
    });
    uploader.on('failed', () => {
      uploader.retry();
      setUploadFlag(false);
      // setUploadInstance(null);
      getUploadInstance(null);
    });
    uploader.on('retry-failed', () => {
      setUploadFlag(false);
      message.error(t('As_CreateProjectRewrite_ErrorUpload'), {
        id: 'upload-video-project-failed',
      });
    });
    uploader.on('getShardlink', () => {
      changePopUpClose(false);
    });
    changePopUpClose(true);
    uploader.upload();
  };

  return (
    <div className="video-rewrite-upload-component">
      <div className="upload_box">
        {fileData ? (
          <AlreadyUploaded
            fileData={fileData}
            videoUrl={videoUrl}
            uploadFlag={uploadFlag}
            progressNum={progressNum}
          />
        ) : (
          <NotUploaded text={text} />
        )}
        {!fileData && (
          <input
            ref={fileRef}
            type="file"
            accept={accept}
            disabled={uploadFlag}
            onClick={() =>
              window.onClickGATrackEvent(
                projectType ? 'addnarration-select-file' : 'rewrite-select-file',
              )
            }
            onDrop={() =>
              window.onClickGATrackEvent(
                projectType ? 'addnarration-select-file' : 'rewrite-select-file',
              )
            }
            onChange={handleUploadAvatar}
          />
        )}
      </div>
    </div>
  );
}

// 未上传状态的组件
function NotUploaded() {
  const { t } = useTranslation();
  return (
    <div className="not_uploaded">
      <Icon name="icon-upload"></Icon>
      <p> {t('As_Edit_UploadClick334')}</p>
      <p>{t('As_Edit_UploadDrop334')}</p>
      <p>
        {t('As_Edit_UploadFormat334')} {t('As_Edit_UploadSize334')}
      </p>
    </div>
  );
}

// 已上传状态的组件
function AlreadyUploaded({ fileData, videoUrl, uploadFlag, progressNum }) {
  return (
    <div className="already_uploaded">
      <video src={videoUrl} muted crossOrigin="anonymous" className="file_input_img"></video>
      <div className="file_name">
        <span>{fileData?.name}</span>

        {uploadFlag && (
          <progress
            className="progress progress-primary w-[250px]"
            value={progressNum}
            max="1"></progress>
        )}
      </div>
    </div>
  );
}
